import React from 'react'
import { Navigate, useOutlet } from "react-router-dom";
import Header from '../components/header/Header';
import SideBar from '../components/sidebar/Sidebar';
import { useAuth } from "../hooks/useAuth";
import { SideBarContext } from '../store/sidebar/context';

import { useLocation } from 'react-router-dom';
import { useShared } from '../hooks/useShared';
import { getLanguage,  } from 'react-multi-lang'
import { ADrawer } from '../components/sidebar/ADrawer';
export default function ProtectedLayout() {
  const { user } = useAuth();
  const { navigate} = useShared();

  const outlet = useOutlet();
  const [pushSideBar, setPushSideBar] = React.useState(true)
  const location = useLocation();
  const {
    setModel,
    setModels,
    setShowSearchBox,
    setShowNewModelDialog,
    setShowViewDialog,
    setShowDeleteDialog,
    setGeneratePDF,
    setGetOnce } = useShared();



  React.useEffect(() => {
    setModel(null);
    setModels(null)
    setShowSearchBox(false)
    setShowNewModelDialog(false)
    setShowViewDialog(false)
    setShowDeleteDialog(false)
    setGetOnce(false)
    setGeneratePDF(false)

  }, [location]);

  React.useEffect(() => {
    
     if(user?.user?.is_new_user===0 && location.pathname!=='/db/profile'){
      navigate('/db/profile', { replace: true }); 
  }
  }, [user])


  if (!user) {
    return <Navigate to="/db/login" />;
   }

   const getDirection = ()=>getLanguage()==='dr'?"rtl":'ltr'
  return (
    <SideBarContext.Provider value={{ pushSideBar, setPushSideBar }}>

      <div className="md:flex md:flex-row  min-h-screen bg-gray-50 text-gray-800 " style={{direction:getDirection()}}>

        {/*    sidebar */}
        <ADrawer />
        <SideBar />
        {/* Contents */}
        <main className=" flex flex-col flex-grow  md:ml-0 transition-all duration-150 ease-in ">
          {/*    Header */}
          <Header />

          {/* Contents */}
          <div className=" flex flex-col  p-2 md:p-4 overflow-y-auto md:h-[90vh]">
            {outlet}
          </div>

          {/* footer */}
         {/*  <Footer /> */}
        </main>
      </div>

    </SideBarContext.Provider>
  );
};
